import { render, staticRenderFns } from "./mid.vue?vue&type=template&id=2f0189c6"
import script from "./mid.vue?vue&type=script&lang=js"
export * from "./mid.vue?vue&type=script&lang=js"
import style0 from "./mid.vue?vue&type=style&index=0&id=2f0189c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports